export default "__VITE_ASSET__0ae287ef__"